import { Dispatch, SetStateAction, useState } from "react";

export function myUseState<T>(initState: T | (() => T)): {
	state: T;
	setState: Dispatch<SetStateAction<T>>;
	updateState: (changes: Partial<T>) => void;
	toggleState: (name: keyof T) => void;
} {
	const [state, setState] = useState<T>(initState);

	function updateState(changes: Partial<T>): void {
		setState(prev => {
			// beze zmeny vratime puvodni objekt -> React preskoci render
			const changed = Object.keys(changes).some(key => !Object.is(prev[key as keyof T], changes[key as keyof T]));

			return changed
				? { ...prev, ...changes }
				: prev;
		});
	}

	function toggleState(name: keyof T) {
		setState(prev => {
			const newValue = prev[name] as boolean;

			return {
				...prev,
				[name]: !newValue,
			};
		});
	}

	return {
		state,
		setState,
		updateState,
		toggleState,
	};
}
